






import { Component, Prop, Vue } from "vue-property-decorator";

import adobeIcon from "../../assets/icons/adobeicon.svg?inline";
import cartIcon from "../../assets/icons/carticon.svg?inline";
import chatIcon from "../../assets/icons/chaticon.svg?inline";
import checkmarkIcon from "../../assets/icons/checkmarkicon.svg?inline";
import closeIcon from "../../assets/icons/closeicon.svg?inline";
import cogIcon from "../../assets/icons/cogicon.svg?inline";
import emailIcon from "../../assets/icons/emailicon.svg?inline";
import excelIcon from "../../assets/icons/excelicon.svg?inline";
import externalIcon from "../../assets/icons/externalicon.svg?inline";
import homeIcon from "../../assets/icons/homeicon.svg?inline";
import leftIcon from "../../assets/icons/lefticon.svg?inline";
import questionIcon from "../../assets/icons/questionicon.svg?inline";
import quoteIcon from "../../assets/icons/quoteicon.svg?inline";
import resultsIcon from "../../assets/icons/resultsicon.svg?inline";
import rightIcon from "../../assets/icons/righticon.svg?inline";
import saveIcon from "../../assets/icons/saveicon.svg?inline";
import telephoneIcon from "../../assets/icons/telephoneicon.svg?inline";
import shareBlueIcon from "../../assets/icons/shareblueicon.svg?inline";
import shareWhiteIcon from "../../assets/icons/sharewhiteicon.svg?inline";
import contactBlueIcon from "../../assets/icons/contactblueicon.svg?inline";
import contactWhiteIcon from "../../assets/icons/contactwhiteicon.svg?inline";
import warningIcon from "../../assets/icons/warningicon.svg?inline";
import communicationIcon from "../../assets/icons/communicationicon.svg?inline";
import exclamationIcon from "../../assets/icons/exclamationicon.svg?inline";
import pagerIcon from "../../assets/icons/pagericon.svg?inline";
import phoneIcon from "../../assets/icons/phoneicon.svg?inline";
import umbrellaIcon from "../../assets/icons/umbrellaicon.svg?inline";
import faArrowRightIcon from "../../assets/icons/fa-arrow-right.svg?inline";
import faArrowLeftIcon from "../../assets/icons/fa-arrow-left.svg?inline";
import faCommentIcon from "../../assets/icons/fa-comment.svg?inline";
import faShareIcon from "../../assets/icons/fa-share.svg?inline";
import faCaretDownIcon from "../../assets/icons/fa-caret-down.svg?inline";
import faCaretUpIcon from "../../assets/icons/fa-caret-up.svg?inline";
import faFileIcon from "../../assets/icons/fa-file.svg?inline";
import faCartIcon from "../../assets/icons/fa-cart-shopping.svg?inline";
import faGearIcon from "../../assets/icons/fa-gear.svg?inline";
import faInfoIcon from "../../assets/icons/infoicon.svg?inline";

@Component({
  components: {
    adobeIcon,
    cartIcon,
    chatIcon,
    checkmarkIcon,
    closeIcon,
    cogIcon,
    emailIcon,
    excelIcon,
    externalIcon,
    homeIcon,
    leftIcon,
    questionIcon,
    quoteIcon,
    resultsIcon,
    rightIcon,
    saveIcon,
    telephoneIcon,
    shareBlueIcon,
    shareWhiteIcon,
    contactBlueIcon,
    contactWhiteIcon,
    warningIcon,
    communicationIcon,
    exclamationIcon,
    pagerIcon,
    phoneIcon,
    umbrellaIcon,
    faArrowRightIcon,
    faArrowLeftIcon,
    faCommentIcon,
    faShareIcon,
    faCaretDownIcon,
    faCaretUpIcon,
    faFileIcon,
    faCartIcon,
    faGearIcon,
    faInfoIcon
  }
})
export default class AdvisorIcon extends Vue {
  @Prop()
  readonly name!: string;

  get svgIconName() {
    return `${this.name}Icon`;
  }

  get svgIconClass() {
    return `${this.name}`;
  }
}
